import { useSurveyForm } from "./helpers/useSurveyForm";
import { SiteSurveyConfiguration } from "api/types/siteSurveyConfiguration";
import { Attribute } from "./helpers/Attribute";
import { Photo } from "api/types/photo";

interface SiteAttributesType {
  config: SiteSurveyConfiguration;
}
export function SiteAttributes({ config }: SiteAttributesType) {
  const { survey, onAttributeValueChange } = useSurveyForm();

  return (
    <>
      {config.attributes.map((attributeConfig, index) => {
        const matchingAttribute = survey.attributes.find(
          (att) => att.attributeId === attributeConfig.id
        );

        function onAttributeValueChangeTmp(attributeValueText: string) {
          onAttributeValueChange(attributeConfig, attributeValueText);
        }

        function onPhotoChangeTmp(photo: Photo) {}

        function onDeletePhotoTmp() {}

        return (
          <Attribute
            key={`attribute-${attributeConfig.id}-${index}`}
            attributeConfig={attributeConfig}
            attributeValue={matchingAttribute}
            onAttributeValueChange={onAttributeValueChangeTmp}
            onPhotoChange={onPhotoChangeTmp}
            onDeletePhoto={onDeletePhotoTmp}
          />
        );
      })}
    </>
  );
}
